module.exports = __webpack_public_path__ + "static/img/c7c4ee7be3eb4e73a19887dc713505145.fdf7a32b.jpg";